import { cleanArray } from './index';

export const countActiveFilters = (
  filter?: object,
  ...ignoredProps: string[]
) => {
  if (!filter) {
    return 0;
  }

  return Object.entries(filter).filter(
    ([key, value]) =>
      !ignoredProps.includes(key) &&
      typeof value !== 'undefined' &&
      value !== null &&
      (!Array.isArray(value) || cleanArray(value).length)
  ).length;
};

export const filterString = (
  value: string | null,
  query: string | number | boolean
) =>
  typeof query === 'string'
    ? (value || '').toLowerCase().includes(query.toLowerCase())
    : false;
